import React, { ReactNode } from 'react';

import cx from 'classnames';
import { useRouter } from 'next/dist/client/router';

import Card, { CardContent } from 'components/Card';
import Link from 'components/Link';

import styles from './PageContainer.module.css';

export interface BreadcrumbProps {
  as?: string;
  href: string;
  title: string;
}
export interface PageContainerProps {
  breadcrumbs: BreadcrumbProps[];
  children: ReactNode;
  cmsContent?: boolean;
  footer?: ReactNode;
  hasLargePadding?: boolean;
  pageTitle?: string;
  preTitle?: ReactNode;
  title?: ReactNode;
}

export function PageContainer({ breadcrumbs, children, cmsContent, pageTitle, preTitle, title: pageContainerHeading }: PageContainerProps) {
  const router = useRouter();

  const stepTitle = (router.query?.stepUrl as string)?.split('-').join(' ');

  const Header = () => {
    return (
      <>
        <div className={styles['PageContainer--Header']}>
          <div className={styles['PageContainer--Title']}>
            <h1 className="h2 h-color--navy text h-font--capitalize">
              {stepTitle} {stepTitle && ':'} {pageContainerHeading}
            </h1>
          </div>
        </div>
      </>
    );
  };

  const Content = () => (cmsContent ? <div className={styles.CMSContent}>{children}</div> : <CardContent>{children}</CardContent>);

  return (
    <Card className={styles.PageContainer} header={pageContainerHeading && <Header />} transparent>
      <Content />
    </Card>
  );
}
